import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/index',
      component: (resolve) => require(['@/views/Layout'], resolve),
    },
    {
      path: '/current_weather',
      component: (resolve) => require(['@/views/current_weather/current_weather'], resolve),
      meta: {
        title: '本地天气',
      },
    },
    {
      path: '/weather_monitor/:id',
      component: (resolve) => require(['@/views/weather_monitor/weather_monitor'], resolve),
    },
    {
      path: '/info_feedback',
      component: (resolve) => require(['@/views/info_feedback/info_feedback'], resolve),
      meta: {
        title: '信息反馈',
      },
    },
    {
      path: '/custom_message',
      component: (resolve) => require(['@/views/custom_message/custom_message'], resolve),
      meta: {
        title: '我的定制',
      },
    },
    {
      path: '/apply_role',
      component: (resolve) => require(['@/views/custom_message/apply_role'], resolve),
      meta: {
        title: '角色申请',
      },
    },
    {
      path: '/msg_list',
      component: (resolve: any) => require(['@/views/custom_message/msg_list'], resolve),
      meta: {
        title: '消息列表',
      },
    },
    {
      path: '/daily_forecast',
      component: (resolve) => require(['@/views/content_manage/daily_forecast'], resolve),
      meta: {
        title: '每日天气预报',
      },
    },
    {
      path: '/meteo_knowledge',
      component: (resolve) => require(['@/views/content_manage/meteo_knowledge'], resolve),
      meta: {
        title: '气象知识',
      },
    },
    {
      path: '/details_view/:id',
      component: (resolve) => require(['@/views/content_manage/details_view'], resolve),
      meta: {
        title: '气象知识详情',
      },
    },
  ],
});
router.beforeEach((to: any, from, next) => {
    // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router
